import { TweenLite } from 'gsap';
import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

export const Animation: React.FC<{
  animationKey: any;
  onlyFade?: boolean;
  direction?: 'none' | 'right' | 'left';
  delay?: number;
  insight?: boolean;
}> = ({
  animationKey,
  children,
  onlyFade = false,
  delay = 0.4,
  direction = null,
  insight = false,
}) => {
  return (
    <TransitionGroup>
      <CSSTransition
        key={animationKey}
        timeout={500}
        onEntering={(node: any) => {
          TweenLite.fromTo(
            node,
            0.3,
            {
              opacity: 0,
              translateX: direction ? 300 : undefined,
            },
            {
              opacity: 1,
              translateX: direction ? 0 : undefined,
            },
          ).delay(delay);
        }}
        onExiting={
          onlyFade
            ? (node: any) => {
                TweenLite.to(node, 0.3, {
                  opacity: 0,
                  translateX: direction ? 0 : undefined,
                });
              }
            : (node: any) => {
                node.style.position = 'absolute';
                node.style.top = 0;
                node.style.left = 0;
                TweenLite.to(node, 0.6, {
                  opacity: 0,
                  translateX: direction && !insight ? -500 : undefined,
                  ease: 'cubic-bezier(0.445, 0.050, 0.550, 0.950)',
                });
              }
        }
      >
        {children}
      </CSSTransition>
    </TransitionGroup>
  );
};
